// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pv-6";
export var imgContainer = "_pv-3";
export var menuIcon = "_pv-5";
export var pillWrapper = "_pv-2";
export var pillsContainer = "_pv-1";
export var subscriptionCard = "_pv-0";
export var subscriptionLogo = "_pv-4";